<div [class]="skinName">
  @if (!updateSuccess) {
    <h2 class="uk-modal-title">
    {{ configService.localeKeys?.subsc_btn_updt_pmnt_info_def }}</h2>
  }
  @if (!updateSuccess) {
    <p class="mobile-p mt-0">
      {{ configService.localeKeys?.edit_payment_details_description }}
    </p>
  }
  @if (!updateSuccess && paymentGateway === 'stripe') {
    <div class="form-card input-container" id="payment-card">
      <ngx-stripe-card-group [formGroup]="stripeTest" [elementsOptions]="elementsOptions">
        <div class="align-input" [ngClass]="{ 'has-error' : stripeTest.controls.name.invalid && !stripeTest.controls.name.pristine }">
          @if (stripeTest.controls.name.untouched || stripeTest.controls.name.valid) {
            <p class="input-placeholder">{{ configService.localeKeys?.cardholder_name }}
            </p>
          }
          @if (stripeTest.controls.name.invalid && stripeTest.controls.name.touched && stripeTest.get('name').hasError('required')
            ) {
            <p class="input-placeholder error-block">{{ configService.localeKeys?.sign_up_desc_ur_nam_req_def}}</p>
          }
          @if (stripeTest.controls.name.invalid && stripeTest.controls.name.touched && !stripeTest.get('name').hasError('required')
            ) {
            <p class="input-placeholder error-block">{{ configService.localeKeys?.['common_keys.desc_ur_name.text']}}</p>
          }
          <input #name formControlName="name" class="input-box form-control" placeholder="{{ configService.localeKeys?.kws_kw_name_def}}" />
        </div>
        <div>
          @if (!(cardNumberValidation?.error?.message || cardNumberValidation?.error?.code)) {
            <p class="input-placeholder stripe-input">
            {{ configService.localeKeys?.card_name }}</p>
          }
          @if (cardNumberValidation?.error?.message) {
            <p class="input-placeholder stripe-input error-block">
            {{(configService.localeKeys?.signup_err_incomplete_card_num) ? configService.localeKeys?.signup_err_incomplete_card_num : cardNumberValidation?.error?.message}}</p>
          }
          <ngx-stripe-card-number (change)="errorValidation($event)" [options]="cardOptions">
          </ngx-stripe-card-number>
        </div>
        <div class="card-cred">
          <div class="w-45">
            @if (!(cardExpiryValidation?.error?.message || cardExpiryValidation?.error?.code)) {
              <p class="input-placeholder stripe-input">
              {{ configService.localeKeys?.['account.expiry_date.text'] }}</p>
            }
            @if (cardExpiryValidation?.error?.message) {
              <p class="input-placeholder stripe-input error-block">
              {{(configService.localeKeys?.signup_err_incomplete_exp_date) ? configService.localeKeys?.signup_err_incomplete_exp_date  : cardExpiryValidation?.error?.message}}</p>
            }
          </div>
          <div class="w-45">
            @if (!(cardCvvValidation?.error?.message || cardCvvValidation?.error?.code)) {
              <p class="input-placeholder stripe-input">
              {{ configService.localeKeys?.security_code }}</p>
            }
            @if (cardCvvValidation?.error?.message) {
              <p class="input-placeholder stripe-input error-block">
              {{(configService.localeKeys?.signup_err_incomplete_security_code) ? configService.localeKeys?.signup_err_incomplete_security_code : cardCvvValidation?.error?.message}}</p>
            }
          </div>
        </div>
        <div class="card-cred">
          <div class="w-45">
            <ngx-stripe-card-expiry (change)="errorValidation($event)" [options]="cardOptions">
            </ngx-stripe-card-expiry>
          </div>
          <div class="w-45 cvc_value">
            <ngx-stripe-card-cvc (change)="errorValidation($event)" [options]="cardOptions">
            </ngx-stripe-card-cvc>
            <span class = "cvvtooltip"><img src="/branding/theme/assets/static_assets/ic-info-on-lbg.svg">
              <span class = "cvvtext"> {{ configService.localeKeys?.acc_dtl_cvv_tooltip_desc || "The three digit CVV number is displayed on the back of the card,to the right of the signature."}} </span>
            </span>
          </div>
        </div>
        <button type="submit" [disabled]="paymentBtnDisabled" id="pay-btn" class="uk-button submit-btn" (click)="payment($event)">{{ configService.localeKeys?.['common_keys.save_changes.btn']}}</button>
        <div class="poweredby"><span><img src="/branding/theme/assets/static_assets/ic-powered-by-stripe.svg"></span><span><img src="/branding/theme/assets/static_assets/ic-secure-ssl-payment.svg"></span></div>
      </ngx-stripe-card-group>
    </div>
  }
  @if (!updateSuccess && paymentGateway === 'adyen') {
    <div id="adyen-card-container"></div>
  }
  @if (updateSuccess) {
    <div class="input-container">
      <!-- <h2 class="uk-modal-title mobile-none">{{ configService.localeKeys?.['plans.success.text']}}</h2> -->
      <app-success icon="/branding/theme/assets/static_assets/ic-success.svg" [toptext]="configService.localeKeys?.['plans.payment_updated.text']" [bottomtext]="configService.localeKeys?.['plans.payment_automatically_processed.text']" [haslottie]="'true'">
      </app-success>
    </div>
  }

</div>